import { ReactGAImplementation } from 'react-ga4'

export const reactGA = new ReactGAImplementation()
